import { Cell } from "@tanstack/react-table";
import { ITransferenceOrder } from "domain/Inventory/Models/ITransferenceOrder";
import { ITransferenceOrderSummary } from "domain/Inventory/Models/ITransferenceOrderSummary";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { useGlobalInventoryContext } from "modules/Inventory/components/SBGlobalInventoryInfoModal";
import React, { forwardRef, useContext, useState } from "react";
import { TransferenceOrderSummarization } from "../TransferenceOrderSummarization";
import { useTransferenceOrderHeaders } from "./useTransferenceOrderHeaders";

import { ITransferenceOrderTableProps } from "./models/ITransferenceOrderTableProps";

const TransferenceOrderTable = forwardRef(
	({ title, rows, containerHeight, summary, onScroll }: ITransferenceOrderTableProps, ref: any) => {
		const { headers } = useTransferenceOrderHeaders();
		const [selectedItems, setSelectedItems] = useState<ITransferenceOrder[]>([]);
		const { openMenuByClientID, isOpen } = useContext(useGlobalInventoryContext);

		const handleClick = (cell: Cell<ITransferenceOrder, any>) => {
			if (cell.column.id === "inventory")
				openMenuByClientID(cell.row.original.productClientID, cell.row.original.destinationStoreClientID);
		};

		return (
			<SBBox>
				<TransferenceOrderSummarization
					summary={summary}
					selectedItems={selectedItems}
				/>
				<SBBox width={isOpen ? "50vw" : "100%"} style={{ transition: "all 0.25s ease", marginTop: "1rem" }}>
					<SBNewTable
						ref={ref}
						hasSelection
						virtualize
						title={title}
						startRows={rows}
						defaultColumns={headers}
						onClick={handleClick}
						onSelect={(_, indices) =>
							setSelectedItems(
								(indices as string[]).map((i) => rows[+i]),
							)
						}
						containerHeight={containerHeight}
						totalCount={summary?.totalCount}
						onScroll={onScroll}
					/>
				</SBBox>
			</SBBox>
		);
	},
);

export default TransferenceOrderTable;
